// Hooks propios del sistema e-learning (Seguridad Vial).
// Los hooks del template quedan planos en app/hooks/ (useFetch, useDropdown, …).

export { default as useCertificatePdfDownload } from "./useCertificatePdfDownload";
export { default as useCourseConfig } from "./useCourseConfig";
export { default as useDebouncedValue } from "./useDebouncedValue";
export { default as useFileUpload } from "./useFileUpload";
export { default as useModuleNav } from "./useModuleNav";
